var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"maintenance-wrapper"},[_c('div',{staticClass:"maintenance-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('maintenance.maintenanceWork')))]),_c('h5',[_vm._v(_vm._s(_vm.$t('maintenance.maintenanceWorkDescription')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }